<template>
  <svg
    width="23"
    height="12"
    viewBox="0 0 23 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.67065 11.7614L0.249499 6.57613C-0.0831694 6.25794 -0.0831694 5.74205 0.249499 5.42386L5.67065 0.238644C6.00332 -0.0795475 6.54269 -0.0795474 6.87535 0.238644C7.20802 0.556835 7.20802 1.07272 6.87535 1.39092L2.9084 5.18522L23 5.18522L23 6.81478L2.9084 6.81478L6.87535 10.6091C7.20802 10.9273 7.20802 11.4432 6.87535 11.7614C6.54268 12.0795 6.00332 12.0795 5.67065 11.7614Z"
      fill="black"
    />
  </svg>
</template>
